/* eslint-disable no-param-reassign */
import { createSlice } from '@reduxjs/toolkit';

import { params } from '@core/components/utility';
import { JOBS_FORM_SLICE_NAME } from '../utility/constants';
import { convertStringToArray } from './reusableComponents';

const initialState = {
	keyword: params.keyword ?? '',
	page: params.page_number ?? 1,
	job_listing_type: convertStringToArray(params.job_listing_type),
	job_listing_category: convertStringToArray(params.job_listing_category),
	job_listing_tag: convertStringToArray(params.job_listing_tag),
	job_listing_company_size:convertStringToArray(params.job_listing_company_size),
	job_listing_industry:convertStringToArray(params.job_listing_industry),
	is_remote_position:convertStringToArray(params.is_remote_position),
	city: params.city ?? '',
	radius: params.radius ?? '',
	isResetClicked: false,
	easy_apply: params.easy_apply ?? '',
};

const jobsFilterSlice = createSlice({
	name: JOBS_FORM_SLICE_NAME,
	initialState,
	reducers: {
		setPage: (state, action) => {
			state.page = action.payload;
			state.isResetClicked = false;
		},
		checkBoxChanged: (state, action) => {
			const { value, slug } = action.payload;

			const index = state[slug].indexOf(value);

			if (index === -1) {
				state[slug].push(value);
			} else {
				state[slug].splice(index, 1);
			}

			// also revert page to 1
			state.page = 1;
			state.isResetClicked = false;
		},
		setKeyword: (state, action) => {
			state.keyword = action.payload;
			state.page = 1;

			state.isResetClicked = false;
		},
		setCity: (state, action) => {
			state.city = action.payload;
			state.page = 1;
			state.isResetClicked = false;
		},
		setRadius: (state, action) => {
			state.radius = action.payload;
			state.page = 1;
			state.isResetClicked = false;
		},
		resetFormReducer: (state, action) => {
			state.keyword = '';
			state.page = 1;
			state.job_listing_type = [];
			state.job_listing_category = [];
			state.job_listing_tag = [];
			state.job_listing_company_size = [];
			state.job_listing_industry = [];
			state.is_remote_position = [];
			state.city = '';
			state.radius = '';
			state.easy_apply = '';
			state.isResetClicked = true;
		},
		setEasyApply: (state, action) => {
			if(action.payload === true) {
				state.easy_apply = action.payload;
			} else {
				state.easy_apply = '';
			}

			state.page = 1;
			state.isResetClicked = false;
		}
	},
	extraReducers: (builder) => {
		builder.addMatcher(
			// Define a matcher for all actions within your slice
			(action) => action.type.startsWith('jobsFormInput/'),
			(state) => {
				let formsData = {
					...state,
				};
				Object.keys(formsData).forEach((key) => {
					/**
					 * By Default, page url was affected somehow by WordPress and it was always redirecting
					 * So, in this case, we change the page key to page_number
					 * @link https://studysmarter.atlassian.net/browse/SPRESS-181
					 */
					if(key === 'page') {
						params['page_number'] = formsData[key]
					} else {
						params[key] = formsData[key];
					}
				});
			},
		);
	},
});

export const {
	setPage,
	checkBoxChanged,
	popularTagsClicked,
	setCity,
	setKeyword,
	setRadius,
	setEasyApply,
	resetFormReducer,
} = jobsFilterSlice.actions;

export default jobsFilterSlice.reducer;
